import { Outlet } from 'react-router-dom';

const InventoryOutlet = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default InventoryOutlet